<template>
  <v-container fluid>

    <!-- 아임포트 상세 정보 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_detail" @keydown.esc="dialog_detail = false" max-width="800px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('edlist_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_detail = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <vue-json-pretty
                :data="iamData"                  
                >
              </vue-json-pretty>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_detail = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>        


    <v-row dense align="center">
      <v-col cols="12" md="2" class="pa-0">
        <v-btn icon @click="back"><v-icon>mdi-arrow-left</v-icon></v-btn>
        <label class="menunamestyle">{{$t('edlist_label2')}}</label>
      </v-col>
      <v-spacer/>
      <v-col cols="12" md="5" class="pa-0">
        <v-row dense no-gutters align="center">
          <v-col cols="8" class="pa-0">
            <v-text-field 
              dense single-line clearable
              @keyup.enter="search_run" 
              v-model="search_keyword" 
              :placeholder="$t('edlist_label3')"
              outlined height="43"
              color="#808080"
              hide-details
              />
          </v-col>
          <v-col cols="2" align="center">
            <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
          </v-col>
        </v-row>
      </v-col>
  </v-row>

  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>
    
  <v-row align="start">
    <v-col class="pa-1">
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        >
        <template v-slot:header.title>
          <label class="cheader_normal" >{{$t("edlist_col1")}}</label>
        </template>
        <template v-slot:header.representativeRecipient>
          <label class="cheader_normal" >{{$t("edlist_col2")}}</label>
        </template>
        <template v-slot:header.senderAddress>
          <label class="cheader_normal" >{{$t("edlist_col3")}}</label>
        </template>
        <template v-slot:header.sendDate>
          <label class="cheader_normal" >{{$t("edlist_col4")}}</label>
        </template>
        <template v-slot:header.emailStatus>
          <label class="cheader_normal" >{{$t("edlist_col5")}}</label>
        </template>

        <template v-slot:item.emailStatus="{ item }">  
          <a @click="getEmailinfo(item.mailId)">{{ item.emailStatus }}</a>
        </template>     

      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="center" justify="center">
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
  </v-row>

  </v-container>
</template>

<script>
import dateFormat from 'dateformat'
import VueJsonPretty from 'vue-json-pretty'
export default {

    components:{
      VueJsonPretty
    },  

    data: () => ({
      REQID: null,
      EVENT_IDX: null,
      COMIDX: null,
      dialog_detail:false,
      iamData:{},

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      sort_name: 'EVENT_END',
      sort_type: true,    //true : DESC, false: ASC

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,


      defaultItem: {
          COM_IDX:'',
          NAME:'',
          COM_NAME:'',
          STATE:1,
          TYPE_IDX: -1,
          TYPENAME: '',
          PART_TYPE:0,
          EVENT_START: dateFormat(new Date(), "yyyy-mm-dd 09:00"),
          EVENT_END:   dateFormat(new Date(), "yyyy-mm-dd 18:00"),
      },
      editedItem: {
      },

      //테이블 정의
      headers: [
        {text: '제목', value: 'title', sortable: false, align:'center', width:250},
        {text: '수신자', value: 'representativeRecipient', sortable: false, align:'center', width:200},
        {text: '발송자', value: 'senderAddress', sortable: false, align:'center', width:200 },
        {text: '발송일시', value: 'sendDate', sortable: false, align:'center', width:250},
        {text: '발송상태', value: 'emailStatus', sortable: false, align:'center', width:200 }
      ],
      itemList: [],
      
      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 100000,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    
      
      SEARCH_COM_IDX: '',
      SEARCH_COM_NAME: '',
      grade : 0,
      
    }),

    mounted(){
      
      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {


      //이메일 발송내역 상세 확인
      getEmailinfo(mailid){
        

          this.$http.post(this.$host+'/api/EmailDetailInfo',{
            MAILID: mailid
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.iamData = result.data.resultData;
              this.dialog_detail = true;
              

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });        
      },            

      back(){
        this.$router.back();
      },

      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){
          
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          
          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/EmailRequestList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , page: this.page
              , pagerow: this.pagerow
              , REQID: this.REQID
              , EVENT_IDX: this.EVENT_IDX
              , COMIDX: this.COMIDX
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.totalcnt = result.data.resultData.totalElements;
              
              this.makepaging();
              const list = result.data.resultData.content;
              list.forEach(element => {
                var temp = {};
                temp.mailId = element.mailId;
                temp.title = element.title;
                temp.emailStatus = element.emailStatus.label;
                temp.senderAddress = element.senderAddress;
                temp.senderName = element.senderName;
                if(element.sendDate != null && element.sendDate.formattedDateTime != null){
                  temp.sendDate = element.sendDate.formattedDateTime;
                }
                temp.representativeRecipient = element.representativeRecipient;
                this.itemList.push(temp); 
              });

              //요걸 나중에 해줘야 무한반복이 안된다.
              this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        this.REQID = this.$route.query.rid;
        this.EVENT_IDX  = this.$route.query.event;
        this.COMIDX     = this.$route.query.com;
        

        //첫페이지 로드
        this.loadpage(1);
      },      

      //검색
      search_run(){
        this.loadpage(1);
      },
      

    },
  
}
</script>


<style lang="css">
  td{
    height: 36px !important;
  }
</style>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>